import usePipelineStatusTranslations from "../../hooks/usePipelineStatusTranslations";

export default function PipelineStatus({ status }) {
	const translations = usePipelineStatusTranslations();

	return translations[status] || null;
}
